export enum ESummaryTabList {
  SUMMARY = 'Summary',
  TASKS = 'Tasks',
  PARTICIPANTS = 'Participants',
  HISTORY = 'Audit Trail',
}
